import { AppState } from '../../common/configuration/app.states';

export const getPatientsConsultations = (state: AppState) => state.consultations.patientsConsultations;

export const getTodaysConsultationsStats = (state: AppState) => state.consultations.todaysConsultationsStats;
